import { Component } from '@angular/core';
import { AccordionContentComponent } from '../accordion_content.component';

@Component({
  selector: 'yi-add-javascript',
  template: require('./woo_add_javascript.component.html'),
  styles: [require('./woo_add_javascript.component.scss')]

})

export class WooAddJavascriptComponent extends AccordionContentComponent {

}
